// data-testid constants for SiteHive
export const NAV = {
  logo: 'nav-logo',
  linkServices: 'nav-link-services',
  linkWork: 'nav-link-work',
  linkProcess: 'nav-link-process',
  linkPricing: 'nav-link-pricing',
  linkContact: 'nav-link-contact',
  ctaStart: 'nav-cta-start',
  mobileToggle: 'nav-mobile-toggle',
  mobileOverlay: 'nav-mobile-overlay',
  liveBadge: 'nav-live-badge',
};

export const HERO = {
  headlinePrimary: 'hero-headline-primary',
  headlineCycle: 'hero-headline-cycle',
  ctaSeeWork: 'hero-cta-see-work',
  ctaQuote: 'hero-cta-quote',
  scrollHint: 'hero-scroll-hint',
};

export const STATS = {
  block: 'stats-block',
};

export const SERVICES = { block: 'services-block', card: (i) => `service-card-${i}` };
export const PROCESS = { block: 'process-block', step: (i) => `process-step-${i}` };
export const PORTFOLIO = { block: 'portfolio-block', card: (i) => `portfolio-card-${i}` };
export const PRICING = { block: 'pricing-block', tier: (name) => `pricing-tier-${name}` };
export const TESTIMONIALS = { block: 'testimonials-block' };

export const CONTACT = {
  block: 'contact-block',
  form: 'contact-form',
  full_name: 'contact-full_name',
  business_name: 'contact-business_name',
  email: 'contact-email',
  phone: 'contact-phone',
  service_type: 'contact-service_type',
  budget: 'contact-budget',
  message: 'contact-message',
  submit: 'contact-submit',
  success: 'contact-success',
  emailCopy: 'contact-email-copy',
  emailToast: 'contact-email-toast',
};

export const ROAST = {
  block: 'roast-block',
  form: 'roast-form',
  name: 'roast-name',
  url: 'roast-url',
  submit: 'roast-submit',
  success: 'roast-success',
};

export const FLOATING = { cta: 'floating-cta' };
export const LOADER = { root: 'loading-screen' };
export const FOOTER = { block: 'footer-block' };
